import React from "react";

const Social = () => {
    return (
        <div className="home__social">
            <a href="https://www.instagram.com/zonei.artz/" className="home__social-icon" target="_blank">
                <i class="uil uil-instagram"></i>
            </a>
        
            <a href="https://www.youtube.com/channel/UCjF3XRGjsZ76cu-w7gLzcmQ" className="home__social-icon" target="_blank">
                <i class="uil uil-youtube"></i>
            </a>

            <a href="https://www.linkedin.com/in/sunny-sur-8839a9294/" className="home__social-icon" target="_blank">
                <i class="uil uil-linkedin-alt"></i>
            </a>

            <a href="https://github.com/Sunnyshub/Projects" className="home__social-icon" target="_blank">
                <i class="uil uil-github-alt"></i>
            </a>

        </div>
    )
}

export default Social